<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Packer Container', apiMethod: 'PackerContainers', form: () => import('../forms/PackerContainerForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Blend Component', apiMethod: 'BlendComponents', parentForeignKey: 'packerContainerId', form: () => import('../forms/BlendComponentForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Blend Components', value: 'packerContainerId', isCard: true, table: () => import('../tables/BlendComponentsTable') },
                ],
                mainForm: () => import('../forms/PackerContainerForm'),
                claimName: 'PackerContainers',
                apiMethod: 'PackerContainers',
            }
        }
    };
</script>
